import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    try {
      const theme = localStorage.getItem("thuvien.ui.theme")
      if (["light", "dark"].includes(theme)) this.element.dataset.theme = theme
    } catch (_) { /* System preference remains the default. */ }
  }

  toggle() {
    const dark = this.element.dataset.theme ? this.element.dataset.theme === "dark" : matchMedia("(prefers-color-scheme: dark)").matches
    this.element.dataset.theme = dark ? "light" : "dark"
    try { localStorage.setItem("thuvien.ui.theme", this.element.dataset.theme) } catch (_) { /* Optional preference. */ }
  }
}
